var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"ci5la","d":"M855 277.11l1.11-1.11 3.89 3.89 3.89-3.89 1.11 1.11-3.89 3.89 3.89 3.89-1.11 1.11-3.89-3.89-3.89 3.89-1.11-1.11 3.89-3.89-3.89-3.89"})),React.createElement("g",{"key":1},React.createElement("g",{"transform":"translate(-855 -276)"},React.createElement("use",{"fill":"#848994","xlinkHref":"#ci5la"})))]);
}

Close.displayName = "Close";

Close.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10"};

module.exports = Close;

Close.default = Close;



//////////////////
// WEBPACK FOOTER
// ./src/assets/close.svg
// module id = 484
// module chunks = 7011981053767 95715928098905 213534597649335